export default __webpack_public_path__ + "static/media/user.f47683c7.svg";